const extensionToAttachmentType = {
  txt: 'file-text',
  doc: 'file-word',
  docx: 'file-word',
  xls: 'file-excel',
  xlsx: 'file-excel',
  pdf: 'file-pdf',
  jpg: 'picture',
  jpeg: 'picture',
  png: 'picture',
  gif: 'picture',
  webp: 'picture',
  zip: 'file',
  ['7z']: 'file',
  rar: 'file',
};

const getAttachmentType = (attachmentName = '') => {
  const extension = attachmentName.split('.').pop();
  let attachmentType = extensionToAttachmentType[extension?.toLowerCase()] || 'file-unknown';
  return attachmentType;
};

export default getAttachmentType;
